import React, { Component } from 'react';
import { Popup, Form } from 'devextreme-react';
import DevExpressDataGrid from 'components/inheritComponent/devexpressdatagrid';
import httpRequest from 'plugin/httprequest';

class ModalClientStatement extends Component {
    constructor(props) {
        super(props);

        this.state = {
            popupVisible: false,
            dataMaster: {}
        };

        this.show = this.show.bind(this)
        this.hide = this.hide.bind(this)

        this.PopupRef = React.createRef()
        this.formRef = React.createRef()
        this.dataGridRef = React.createRef()

        this.dataTable = []

        this.formItems = [
            {
                dataField:"participantName",
                label:{
                    text:"Pemberi Kerja"
                },
                editorOptions: {
                    elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                    placeholder: 'Kode User'
                }
            },
            {
                dataField:"nik",
                label:{
                    text:"NIK",
                },
                editorOptions: {
                    elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                }
            },
            {
                dataField:"fullName",
                label:{
                    text:"Nama Karyawan"
                },
                editorOptions: {
                    elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                    placeholder: 'Nama User',
                }
            },
            {
                dataField:"birthDate",
                label:{
                    text:"Tanggal Lahir",
                },
                editorType: "dxDateBox",
                editorOptions: {
                    elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                    useMaskBehavior: true,
                    width: '100%',
                    displayFormat: 'dd MMM yyyy'
                }
            },
            {
                dataField:"historyDate",
                label:{
                    text:"Tanggal Riwayat",
                },
                editorType: "dxDateBox",
                editorOptions: {
                    elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                    useMaskBehavior: true,
                    width: '100%',
                    displayFormat: 'dd MMM yyyy'
                }
            },
            {
                dataField:"productName",
                label:{
                    text:"Produk Dana Pensiun",
                },
                editorOptions: {
                    elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                }
            },
            {
                dataField:"kepesertaanDate",
                label:{
                    text:"Tanggal Kepesertaan",
                },
                editorType: "dxDateBox",
                editorOptions: {
                    elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                    useMaskBehavior: true,
                    width: '100%',
                    displayFormat: 'dd MMM yyyy'
                }
            },
            {
                dataField:"umurKepesertaan",
                label:{
                    text:"Umur Kepesertaan",
                },
                editorOptions: {
                    elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
                }
            },
        ]

        this.columns = [
            {
                dataField: 'id',
                caption: 'NO',
                dataType: 'number'
            },
            {
                dataField: 'transactionDate',
                caption: 'TANGGAL TRANSAKSI',
                dataType: 'date',
                format: 'dd MMM yyyy'
            },
            {
                dataField: 'transactionType',
                caption: 'JENIS TRANSAKSI',
                dataType: 'string'
            },
            {
                dataField: 'transactionNote',
                caption: 'KETERANGAN TRANSAKSI',
                dataType: 'string'
            },
            {
                dataField: 'transactionNominal',
                caption: 'NOMINAL TRANSAKSI',
                dataType: 'number',
                format: '#,##0.00'
            },
            {
                dataField: 'transactionFee',
                caption: 'BIAYA TRANSAKSI',
                dataType: 'number',
                format: '#,##0.00'
            },
            {
                dataField: 'pajakNominal',
                caption: 'PAJAK',
                dataType: 'number',
                format: '#,##0.00'
            },
            {
                dataField: 'nettNominal',
                caption: 'NOMINAL BERSIH',
                dataType: 'number',
                format: '#,##0.00'
            },
            {
                dataField: 'navValue',
                caption: 'NILAI AKTIVA TRANSAKSI',
                dataType: 'number',
                format: '#,##0.00'
            },
            {
                dataField: 'transactionUnit',
                caption: 'UNIT TRANSAKSI',
                dataType: 'number',
                format: '#,##0.00'
            },
            {
                dataField: 'saldoUnit',
                caption: 'SALDO UNIT',
                dataType: 'number',
                format: '#,##0.00'
            },
            {
                dataField: 'saldoNominal',
                caption: 'SALDO NOMINAL',
                dataType: 'number',
                format: '#,##0.00'
            }
        ];

        this.summary = [
            {
                name: 'total',
                showInColumn: 'transactionDate',
                displayFormat: 'TOTAL :'
            },
            {
                column: 'transactionNominal',
                summaryType: 'sum',
                valueFormat: '#,##0.00',
                name: 'transactionNominal',
                displayFormat: '{0}'
            },
            {
                column: 'transactionFee',
                summaryType: 'sum',
                valueFormat: '#,##0.00',
                name: 'transactionFee',
                displayFormat: '{0}'
            },
            {
                column: 'pajakNominal',
                summaryType: 'sum',
                valueFormat: '#,##0.00',
                name: 'pajakNominal',
                displayFormat: '{0}'
            },
            {
                column: 'nettNominal',
                summaryType: 'sum',
                valueFormat: '#,##0.00',
                name: 'nettNominal',
                displayFormat: '{0}'
            },
            {
                column: 'navValue',
                summaryType: 'sum',
                valueFormat: '#,##0.00',
                name: 'navValue',
                displayFormat: '{0}'
            },
            {
                column: 'transactionUnit',
                summaryType: 'sum',
                valueFormat: '#,##0.00',
                name: 'transactionUnit',
                displayFormat: '{0}'
            },
            {
                column: 'saldoUnit',
                summaryType: 'sum',
                valueFormat: '#,##0.00',
                name: 'saldoUnit',
                displayFormat: '{0}'
            },
            {
                column: 'saldoNominal',
                summaryType: 'sum',
                valueFormat: '#,##0.00',
                name: 'saldoNominal',
                displayFormat: '{0}'
            }
        ];

        this.PopupToolbarItem = [
            {
                widget: "dxButton",
                location: "after",
                options: {
                    text: "Batal",
                    elementAttr: { class: "bg-button-popup-close-dapen-default" },
                    onClick: this.hide.bind(this)
                },
                toolbar: "bottom"
            }
        ];
    }

    show = () => {
        this.setState({
            popupVisible: true,
        });
    }

    hide = () => {
        this.setState({
            dataMaster: {},
            popupVisible: false
        });
    }

    retrieveData = async(data) => {
        if(data){
            const getKp = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `wp/pesertas/kp/${data.kpId}`, 'GET')
            const getIuran = await httpRequest(process.env.REACT_APP_BACKEND_CORE, this.props.store, `wp/pesertas/client-statement/${data.kpId}`, 'GET')
            const dataForm = {
                participantName: getKp.participantName,
                nik: getKp.nik,
                fullName: getKp.fullName,
                birthDate: getKp.birthDate,
                historyDate: new Date(),
                productName: getIuran[0].productName,
                kepesertaanDate: getIuran[0].tanggalEfektifAkun,
                umurKepesertaan: `${getIuran[0].ageYear} Tahun ${getIuran[0].ageMonth} Bulan`
            }

            this.dataTable = getIuran
            this.setState({
                dataMaster: dataForm
            })

            this.dataGridRef.current.forceRefresh(true)

        }
    }

    loadData = () => {
        return this.dataTable
    }

    render() {
        return (
            <Popup
                className={'popup'}
                visible={this.state.popupVisible}
                onHiding={this.hide}
                dragEnabled={false}
                showTitle={true}
                title={'Client Statement'}
                width={1200}
                height={'auto'}
                toolbarItems={ this.PopupToolbarItem }
                ref={this.PopupRef}
            >
                <Form
                    ref={this.formRef}
                    colCount={1}
                    id={'formStatement'}
                    formData={this.state.dataMaster}
                    items={this.formItems}
                    labelLocation='left'
                />

                <div className='row'>
                    <div className='col-12'>
                        <DevExpressDataGrid
                            keyField='kpId'
                            ref={this.dataGridRef}
                            loadAPI='-'
                            insertAPI='-'
                            updateAPI='-'
                            deleteAPI='-'

                            useArraySource={true}
                            ArraySourceData={this.loadData}

                            allowAdding={false}
                            allowDeleting={false}
                            allowUpdating={false}

                            exportExcel={false}
                            exportFileName={"Client-Statement"}
                            allowExportSelectedData={true}

                            height = '40vh'

                            showBorders={true}

                            paging={true}
                            defaultPageSize={10}

                            popupTitle={'Client Statement'}
                            popupWidth={700}
                            popupHeight={500}

                            popupFormLabelLocation='left'
                            popupFormMinColWidth={300}
                            popupFormColCount={3}

                            ColumnChooser={true}
                            ColumnFixing={true}

                            FilterRow={true}

                            ColumnConfiguration={this.columns}
                            SummaryConfiguration={this.summary}

                            summaryTotalItem={this.summary}
                        />
                    </div>
                </div>
            </Popup>
        );
    }
}

export default ModalClientStatement;
